define(['jquery', 'globalVars'], ($, { $body }) => {
    return {
        options: {
            salonItemSelector: '[data-role=salon-item]',
            showPhoneSelector: '.js-show-phone',
            gtmSalonDataSelector: '[data-role-gtm=salon-data]',
        },

        init() {
            this.initEvents();
        },

        initEvents() {
            $body.on(
                'click',
                this.options.showPhoneSelector,
                this.onShowPhoneClick
            );
            $body.on(
                'click',
                this.options.gtmSalonDataSelector,
                this.onGtmSalonDataClick.bind(this)
            );
        },

        onShowPhoneClick(event) {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'uaevent',
                    GaEventCategory: `${window.locationName} Locator`,
                    GaEventAction: 'Show Phone',
                    GaEventLabel: `${
                        window.locationName
                    } Locator Show Phone ${$(event.target)
                        .closest(this.options.showPhoneSelector)
                        .data('name')}`,
                });
            }
        },

        onGtmSalonDataClick(event) {
            const $target = $(event.currentTarget),
                action = $target.data('gtm-action'),
                label = $target.data('gtm-label'),
                name = $target.data('gtm-name'),
                salon = $target.data('gtm-salon');

            this.setDataLayer(salon, name, action, label);
        },

        setDataLayer(salon, name, action, label) {
            if (typeof dataLayer === 'undefined') {
                return;
            }

            const isStoreTab = (window.locationKey === 'sale_points');

            if (name === 'call') {
                name = isStoreTab ? 'call_a_store' : 'call_a_salon';
            } else if (name === 'book') {
                name = isStoreTab ? 'book_a_store' : 'book_a_salon';
            }

            dataLayer.push({
                event: 'uaevent',
                eventCategory: isStoreTab ? 'store_locator' : 'salon_locator',
                eventAction: action,
                eventLabel: label,
                event_name: name,
                store_name: salon,
            });
        },
    };
});
